import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const Text = styled.div`
  font-size: 12px;
  color: ${colors.titleStrongWhite};
`
